import * as React from "react";
import PageLayout from "../components/Shared/PageLayout";
import ProfilePage from "./profile";
import { EDPageLoader, EEDAnimation, IEDPageParallaxBackgroundImage } from "@trailblazer-game/ed-webkit";
import dynamic from "next/dynamic";

const Ranking = dynamic(() => import("../components/Pages/Ranking/Public/Ranking"), {
    suspense: false,
    ssr: false,
    loading: () => <EDPageLoader in={true} />,
})

const PARALLAX_IMAGES: IEDPageParallaxBackgroundImage[] = [
    {
        src: "/ParallaxBackgrounds/Rankings/01.png",
        size: "contain",
        position: "bottom",
        animation: {
            animations: [ EEDAnimation.FadeIn ],
            duration: '1s',
            ease: 'ease-in'
        }
    },
    {
        src: "/ParallaxBackgrounds/Rankings/02.png",
        size: "cover",
        position: "bottom",
        animation: {
            duration: '1s',
            animations: [ EEDAnimation.SlideInLeft, EEDAnimation.FadeIn ],
            ease: 'ease-out'
        }
    },
    {
        src: "/ParallaxBackgrounds/Rankings/03.png",
        size: "contain",
        position: "50% 40%",
        animation: {
            animations: [ EEDAnimation.SlideInRight, EEDAnimation.FadeIn ],
            duration: '1s',
            ease: 'ease-in-out'
        }
    },
    {
        src: "/ParallaxBackgrounds/Rankings/04.png",
        size: "cover",
        position: "bottom",
        animation: {
            animations: [ EEDAnimation.SlideInLeft, EEDAnimation.FadeIn ],
            duration: '1s',
            ease: 'ease-out'
        }
    }
];
export default function RankingPage() {
    return <PageLayout backgroundImages={PARALLAX_IMAGES} backgroundImage={"/ParallaxBackgrounds/Rankings/05.png"}
                       backgroundColor={'rgba(0,0,0,0.5)'}>
        <Ranking />
    </PageLayout>
}

ProfilePage.metaData = {
    title: 'Eternal Dragons Universe - Dragons'
}